import smoothscroll from 'smoothscroll-polyfill';
smoothscroll.polyfill();

import { tns } from '../../node_modules/tiny-slider/src/tiny-slider';

(function () {

  // if (!document.body.classList.contains('home')) return this;
  if (!document.getElementById('picnum')) return this;

  const slider = tns({
    autoHeight: 'auto',
    container: '.picbook',
    items: 1,
    slideBy: 'page',
    loop: false,
    navPosition: 'top',
    controlsPosition: 'bottom',
    mouseDrag: 'true',
    controlsText: ['前のページ', '次のページ'],
  });

  slider.events.on('transitionStart', function (info, eventName) {
    document.getElementById('story').scrollIntoView({ behavior: 'smooth' });
  });

  slider.events.on('transitionEnd', function (info, eventName) {
    const num = document.getElementById('picnum');
    num.innerHTML = ++info.index + '/' + info.pages;
  });

  // var toStoryButton = document.getElementById('toStory');
  // toStoryButton.onclick = function () {
  //   document.getElementById('story').scrollIntoView({ behavior: 'smooth' });
  //   return false;
  // };

})();
